import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useOffline } from '../hooks/useOffline';

export const OfflineBanner: React.FC = () => {
  const { isOffline, connectionType } = useOffline();

  const getBannerContent = () => {
    if (isOffline) {
      return {
        icon: '📱',
        title: 'Playing Offline',
        message: 'You\'re playing in offline mode. Your progress is saved locally and will sync when you reconnect.',
        bgColor: 'bg-blue-500',
        textColor: 'text-white'
      };
    }
    
    if (connectionType === 'slow') {
      return {
        icon: '🐌',
        title: 'Slow Connection',
        message: 'Your connection seems slow. The game works offline, so don\'t worry if features are delayed.',
        bgColor: 'bg-yellow-500',
        textColor: 'text-white'
      };
    }
    
    return null;
  };

  const content = getBannerContent();

  return (
    <AnimatePresence>
      {content && (
        <motion.div
          initial={{ y: -100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: -100, opacity: 0 }}
          transition={{ duration: 0.3 }}
          className={`${content.bgColor} ${content.textColor} px-4 py-3 shadow-lg`}
        >
          <div className="container mx-auto flex items-center justify-center gap-3 text-sm md:text-base">
            <span className="text-xl">{content.icon}</span>
            <div className="flex-1 text-center">
              <span className="font-semibold">{content.title}:</span>
              <span className="ml-2">{content.message}</span>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}; 